import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'handleFunction',
  standalone: false,
  pure: true,
})
export class HandleFunctionPipe implements PipeTransform {
  transform<T, A extends unknown[], R>(
    data: T,
    formatFunction: (data: T, ...args: A) => R,
    ...args: A
  ): R {
    return formatFunction(data, ...args);
  }
}
